<content *ngIf="eidosObject">
  <!-- <eidos-icon
    *ngIf="isFiltered"
    [iconConfiguration]="filterIcon"
    [tooltip]="filterIconLabel"
    class="eidos-obj-filtered-icon">
  </eidos-icon> -->
<eidos-object [eidosObject]="eidosObject"></eidos-object>
</content>
